import { create } from 'zustand';

interface QuotaErrorState {
  error: unknown | null;
  isOpen: boolean;
  open: (error: unknown) => void;
  close: () => void;
}

/**
 * Global quota-error gate. The Axios response interceptor calls
 * `open(err)` whenever a 402 / `*_QUOTA_EXCEEDED` / `PLAN_LIMIT_*`
 * error comes back; the `<QuotaErrorGate />` mounted at the app
 * root subscribes and renders the shared `<QuotaExceededDialog />`.
 *
 * Single dialog instance for every quota across the app — KDS
 * screens, users, branches, warehouses, products, etc. — so the
 * upgrade UX stays consistent.
 */
export const useQuotaErrorStore = create<QuotaErrorState>((set) => ({
  error: null,
  isOpen: false,
  open: (error) => set({ error, isOpen: true }),
  close: () => set({ isOpen: false, error: null }),
}));
